// libs
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

// Actions
import actions from '../../../actions/page';

// Component
import TitleUnderlined from '../home/parts/banner/TitleUnderlined';
import FlexibleContents from './flexibleContents/FlexibleContents';
import Loader from '../../tools/loader/Loader';
import Breadcrumbs from '../../tools/breadcrumbs/Breadcrumbs';

// Functions
import { getHelmetTags, getLoadingHelmetTags } from '../../tools/helmetHelpers';

// Styles
import './styles.scss';

// Proptypes & Context
const propTypes = {
  slug: PropTypes.string.isRequired,
  getPageData: PropTypes.func.isRequired,
  getPagePreviewData: PropTypes.func.isRequired,
  id: PropTypes.number.isRequired,
  pageData: PropTypes.object.isRequired,
  preview: PropTypes.bool,
  isLoading: PropTypes.bool.isRequired,
};

const defaultProps = {
  preview: false,
};

const contextTypes = {
  customStore: PropTypes.object,
  initialRender: PropTypes.bool,
  t: PropTypes.func,
};

class Default extends Component {
  constructor(props, { customStore, initialRender }) {
    super(props);
    const {
      getPageData,
      getPagePreviewData,
      id,
      preview,
      slug,
    } = props;
    if (initialRender) {
      if (preview) {
        getPagePreviewData(id, customStore);
      } else {
        getPageData(slug, customStore);
      }
    }
  }

  componentDidMount() {
    const {
      getPageData,
      getPagePreviewData,
      id,
      pageData,
      preview,
      slug,
    } = this.props;
    if (!Object.keys(pageData).length > 0) {
      if (preview) {
        getPagePreviewData(id);
      } else {
        getPageData(slug);
      }
    }
  }

  componentDidUpdate(prevProps) {
    const { slug: prevSlug } = prevProps;
    const { slug, getPageData } = this.props;
    const { customStore } = this.context;
    if (prevSlug !== slug) {
      getPageData(slug, customStore);
    }
  }

  render() {
    const {
      pageData: {
        seoData,
        title,
        content,
      },
      isLoading,
    } = this.props;
    const { t } = this.context;
    return (
      <div className="default-page">
        {isLoading ? getLoadingHelmetTags(t) : getHelmetTags(t, seoData)}
        {isLoading ?
          <Loader loading={isLoading} fullscreen />
          :
          <React.Fragment>
            {title &&
            <div className="default-page__header">
              <Breadcrumbs title={title} />
              <TitleUnderlined title={title} />
            </div>
            }
            {content &&
            <FlexibleContents flexibleContents={content} />
            }
          </React.Fragment>
        }
      </div>
    );
  }
}

Default.propTypes = propTypes;
Default.defaultProps = defaultProps;
Default.contextTypes = contextTypes;

function mapStateToProps(state) {
  return {
    pageData: state.page.pageData,
    isLoading: state.page.isLoading,
  };
}

export default withRouter(connect(mapStateToProps, actions)(Default));



// WEBPACK FOOTER //
// ./src/app/components/pages/default/Default.js